<template>
  <div class="v-data-table  report bordered--table  theme--light">
    <template v-for="(item, index) in list">
      <template v-if="filter.groupactivities ? true : true">
        <!-- item.projectnumber && item.projectname -->
        <v-simple-table class="report table-bordered" v-if="type === 'all' || type === 'estimation'"  :key="index">
          <tbody>
            <tr style="background: #354759!important; color: #fff;">
              <td :colspan="headers.length">
                <strong v-if="item.projectnumber || item.projectname"> {{ $t('project') }}: {{ item.projectnumber ? ' - ' + item.projectname : item.projectname || '' }}</strong>
              </td>
            </tr>
            <tr v-if="item.hours && item.hours.length">
              <template v-for="(head, index) in headers">
                <td v-if="filter.groupactivities ? groupByActivitySupportedHeaders.includes(head.name) : true" :width="!filter.groupactivities ? head.width : 100 / 3 + '%'" :class="head.class" :key="index">
                  <strong>{{ $t(head.text) }}</strong></td>
              </template>
            </tr>
            <template v-for="hour in item.hours">
              <tr :key="hour.id">
                <template v-for="(head, index) in headers">
                  <td v-if="filter.groupactivities ? groupByActivitySupportedHeaders.includes(head.name) : true" :class="head.class" :key="index" :width="head.width">
                    <!-- <template v-if="head.name === 'date'">{{ $formatter.formatDate(hour[head.name], 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY') }}</template> -->
                    <template v-if="head.name === 'date'"> <span class="d-inline-block text-truncate">{{ $formatter.formatDate(hour[head.name], '', userDetails.dateformat) }}</span> </template>
                    <template v-else-if="head.name === 'hours'">{{ hour[head.name] - hour['breakhr'] | replaceDotWithComma }}</template>
                    <template v-else-if="['breakhr', 'toinvoice'].includes(head.name)" >{{ hour[head.name] | replaceDotWithComma }}</template>
                    <template v-else-if="head.name === 'state'" >{{ getStateName(hour[head.name]) }}</template>
                    <template v-else-if="head.name === 'startEndTime'" >{{ hour.isabsence ? $t('notApplicableAbsence') : hour.start_date && hour.end_date ? $formatter.checkForIsSameDateTimeOrInvertedTimeRange(hour.start_date, hour.end_date) && $formatter.formatDate(hour.end_date, 'DD.MM.YYYYTHH:mm:ss', 'HH:mm') === '00:00' && hour.type === "working" ? $formatter.formatDate(hour.start_date, 'DD.MM.YYYYTHH:mm:ss', 'HH:mm')+ ' - ' : getTime(hour) : '' }}</template>
                    <template v-else-if="head.name === 'worktype_name'" > {{ hour[head.name] ? `${hour.worktype_number || ''} - ${ hour[head.name] || ''}` : '' }} </template>
                    <template v-else>{{ hour[head.name] }}</template>
                  </td>
                </template>
              </tr>
            </template>
            <tr style="background: rgb(255, 186, 192) !important;">
              <td :colspan="headers.length">
                <strong>{{ $t('total') }}: <strong>{{ $formatter.getSumBy(item.hours, x => x.hours) | replaceDotWithComma }}</strong></strong> &nbsp;&nbsp;&nbsp;
                <strong>{{ $t('totalToInvoice') }}: <strong>{{ $formatter.getSumBy(item.hours, x => x.toinvoice) | replaceDotWithComma }}</strong></strong></td>
            </tr>
            <tr style="background: rgb(255, 186, 192) !important;" v-if="type === 'estimation' && item.projectid">
              <td :colspan="headers.length">
              <strong>{{ $t('estimation') }}: {{ item.estimationhrs | replaceDotWithComma }}</strong> &nbsp;&nbsp;&nbsp;
              <strong class="float-right">{{ $t('progress') }}: {{ item.progress || '0' | replaceDotWithComma }} %</strong>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </template>
    </template>
    <v-simple-table class="report table-bordered" v-if="type === 'sum'">
      <tbody>
        <tr style="background: rgb(53, 71, 89) !important; color: rgb(255, 255, 255);">
          <td width="70%"><strong>{{ $t('project') }}</strong></td>
          <td width="30%"><strong>{{ $t('total') }}</strong></td>
        </tr>
        <template v-for="item in list">
          <tr :key="item.projectid">
            <td>
              <template>{{ item.projectnumber || '' }}
              {{ item.projectnumber ? ' - ' + item.projectname : item.projectname || '' }}</template>
            </td>
            <td>{{ $formatter.getSumBy(item.hours, x => x.hours) - $formatter.getSumBy(item.hours, x => x.breakhr) | replaceDotWithComma }}</td>
          </tr>
        </template>
      </tbody>
    </v-simple-table>
    <v-simple-table class="report table table-bordered" v-if="type === 'sum_both'">
       <tbody>
        <tr style="background: rgb(53, 71, 89) !important; color: rgb(255, 255, 255);">
          <td width="20%"><strong>{{ $t('project') }}</strong></td>
          <td width="20%"><strong>{{ $t('total') }}</strong></td>
          <td colspan="1"><strong>{{ $t('estimation') }} </strong></td>
          <td colspan="1"><strong>{{ $t('progress') }}</strong></td>
        </tr>
        <template v-for="project in list">
          <tr :key="project.projectid">
            <td>
              <template v-if="project.projectid">{{ project.projectname }}</template>
              <template v-else><b>{{ $t('absence') }}</b></template>
            </td>
            <td>{{ $formatter.getSumBy(project.hours, x => x.hours) - $formatter.getSumBy(project.hours, x => x.breakhr) | replaceDotWithComma }}</td>
            <td>{{ project.estimationhrs }}</td>
            <td>{{ project.progress | replaceDotWithComma }} % </td>
          </tr>
        </template>
      </tbody>
    </v-simple-table>
  </div>
</template>
<script>
export default {
  props: ['type', 'list', 'headers', 'filter'],
  filters: {
    replaceDotWithComma (value) {
      if (value) {
        return value.toString().replace('.', ',')
      }
    }
  },
  data () {
    return {
      groupByActivitySupportedHeaders: ['worktype_name', 'hours', 'toinvoice']
    }
  },
  methods: {
    getStateName (state) {
      switch (state) {
        case this.DELIVERED:
          return this.$t('delivered')
        case this.NOT_DELIVERED:
          return this.$t('notDelivered')
        case this.NOT_APPROVED:
          return this.$t('notApproved')
        case this.APPROVED:
          return this.$t('approved')
      }
    }
  }
}
</script>
<style>
.bordered--table table, .bordered--table table thead tr, .bordered--table table tbody tr {
  border-collapse: collapse;
  width: 100%;
}
</style>
